import * as React from 'react'

export type ChartType = 'line_chart' | '9_box_grid' | 'employee_pulse' | 'engagement_signals'

const ChartContext = React.createContext<
  [ChartType, React.Dispatch<React.SetStateAction<ChartType>>]
>(['line_chart', () => null])
type PromptProps = {
  children: React.ReactNode
}
const ChartProvider = ({ children }: PromptProps) => {
  const promptStateAndAction = React.useState<ChartType>('line_chart')

  return <ChartContext.Provider value={promptStateAndAction}>{children}</ChartContext.Provider>
}

export { ChartProvider }
